const SetCookie = (cookieName, newValue) => {
    document.cookie=cookieName+'='+newValue
};

export default SetCookie;